/* ShimmerText.tsx generated by @compiled/babel-plugin v0.40.0 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=%40keyframes%20k1cqqt0g%7B0%25%7Bbackground-position%3A200%25%200%7Dto%7Bbackground-position%3A-200%25%200%7D%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._11q7gl65%7Bbackground%3Alinear-gradient(90deg%2Cvar(--ds-text-subtlest%2C%236b6e76)%200%2Cvar(--ds-text-subtlest%2C%236b6e76)%2020%25%2C%23c7cddc%2040%25%2Cvar(--ds-text-subtlest%2C%236b6e76)%2060%25%2Cvar(--ds-text-subtlest%2C%236b6e76)%2080%25%2C%23c7cddc%2090%25%2Cvar(--ds-text-subtlest%2C%236b6e76)%20100%25)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._y44vgcf4%7Banimation%3Ak1cqqt0g%204s%20linear%20infinite%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1lrwm4tz%7Bbackground-size%3A200%25%20100%25%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._pjrq1kdv%7B-webkit-background-clip%3Atext%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._oo9g1j28%7B-webkit-text-fill-color%3Atransparent%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1y1m1kdv%7B-webkit-background-clip%3Atext%3Bbackground-clip%3Atext%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1reo15vq%7Boverflow-x%3Ahidden%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._18m915vq%7Boverflow-y%3Ahidden%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1bto1l2s%7Btext-overflow%3Aellipsis%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._o5721q9c%7Bwhite-space%3Anowrap%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1ul9idpf%7Bmin-width%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1bsb1osq%7Bwidth%3A100%25%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._p12f1osq%7Bmax-width%3A100%25%7D");
import { Text } from '@atlaskit/primitives/compiled';
const shimmerAnimation = null;
const shimmerGradient = null;

/** Single-line ellipsis + flex/grid-safe width. */
const truncateSingleLine = null;
type ShimmerTextProps = {
  children: React.ReactNode;
  size?: 'small' | 'medium' | 'large';
  weight?: 'regular' | 'medium' | 'semibold';
  /**
   * Truncation is applied on this wrapper (not `Text maxLines`) so the
   * gradient and ellipsis share one box and `white-space` does not break clamping.
   * @default false
   */
  truncate?: boolean;
};
export const ShimmerText = ({
  children,
  size = 'medium',
  weight = 'regular',
  truncate = false
}: ShimmerTextProps): JSX.Element => {
  return <div className={ax(["_11q7gl65 _y44vgcf4 _1lrwm4tz _pjrq1kdv _oo9g1j28 _1y1m1kdv", truncate && "_1reo15vq _18m915vq _1bto1l2s _o5721q9c _1ul9idpf _1bsb1osq _p12f1osq"])}>
			<Text size={size} weight={weight} color="color.text.subtlest">
				{children}
			</Text>
		</div>;
};